module.exports = __webpack_public_path__ + "static/img/voroStand2.a83346e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/makeVoroStand/imgs/voroStand2.jpg
// module id = 5BVT
// module chunks = 2